import { Button, Card, Stack,Box,Checkbox,IconButton } from "@mui/material";
import { Properties } from "./properties";
import React, { useEffect, useState } from 'react';
import axios from "axios";
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import $ from 'jquery';
import Recommend from '../assets/image_36.png' 
import NoImage from '../assets/No-Image-Found.jpg' 

const label = { inputProps: { 'aria-label': 'Checkbox demo' } }
export const SupplierCard = ({ supplier,onCheckboxClick }: { supplier: any,  onCheckboxClick: (email: string, isChecked: boolean) => void;    }) => {
  const [isBookmarked, setIsBookmarked] = useState(false);
  const [userId, setUserId] = useState<string | null>(null);
  const [isChecked, setIsChecked] = useState(false);
  useEffect(() => {
    const userDataString = localStorage.getItem('user');
    const userData = userDataString ? JSON.parse(userDataString) : null;
    const storedUserId = userData ? userData.user.user_id : null;
    if (storedUserId) {
      setUserId(storedUserId);
    }
  }, []);

  const handleCheckboxClick = () => {
    setIsChecked(!isChecked);
    if (onCheckboxClick) {
      onCheckboxClick(supplier.email, !isChecked); // Pass email and checkbox state to the parent component
    }
  };

  const handleBookmarkClick = async (userId: string | null, title: string, url: string, part_number: string, model_name: string, isBookmarked: boolean) => {
      try {
        const response = await axios.post(
          'http://pssoftgroup.com/demo/infindbot/bookmark.php',
          { userId, part_number, title, url,model_name,isBookmarked  },
          { headers: { 'Content-Type': 'application/json' } }
        );
        if (response.status === 200) {
          if(response.data.success === true){
            const $ul = $(".recommendations");
            const $p = $(".NoDataRec");
            $p.remove();
            const dataa = `<li key={index} style="list-style-type: none;"><div style="display: flex; align-items: baseline; gap: 9px;" ><img src=${Recommend} style="position: relative; top: 3px;" /><p style="font-size: 14px; margin-bottom: 2px;">${title}"_"${part_number}</p></div></li>`;
            $ul.append(dataa);

          }
          setIsBookmarked((prev) => !prev);
        } else {
          throw new Error('Network response was not ok');
        }
      } catch (error: any) {
        console.error('Error adding bookmark:', error.message);
      }
    };

  return (
    <Card sx={{ maxWidth: "100%", height:"100%" }}>
      <Stack direction={"column"} spacing="5px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
      <Checkbox
          checked={isChecked}
          onChange={handleCheckboxClick}
          style={{ padding: '0px' }}
          aria-hidden
        />
          <IconButton onClick={() => handleBookmarkClick(userId, supplier?.name, supplier?.email, supplier?.location, supplier?.phone_number, isBookmarked)} color="default"  style={{ color: 'black', padding:"0px", border:"1px solid", borderRadius: "0px"  }}>
                 {isBookmarked ? <StarIcon /> : <StarBorderIcon />}
               </IconButton>
          
          </Box>

          {supplier.image_url ? <img src={supplier.image_url} alt="" width={"100%"} height="150px" style={{objectFit:"cover"}} /> : <img src={NoImage} alt="" width={"100%"} height="150px" style={{objectFit:"cover"}} />}

          
          <Stack direction={"column"} spacing="10px" padding="20px">
            {supplier?.name && <Properties keyString={'Supplier'} value={supplier?.name}/>}
            {supplier?.location &&  <Properties keyString="Location" value={supplier.location}/>}

          
          <Button variant="outlined" 
          // onClick={() => { setOpenDetails(true);
          //     setResultsFor(resultPosition)}}
              >
              View details
          </Button>
          <Button
            variant="outlined"
          >
           <a href={`mailto:${supplier.email}`} style={{ textDecoration: 'none', color: 'inherit' }}>
              Chat
            </a>
          </Button>
        </Stack>
      </Stack>
    </Card>
  );
};
